import { Grid } from '@material-ui/core';
import './homepage.scss';
import React from 'react';
import InvestmentPropositionTile from './components/InvestmentPropositionTile';
import ResourcesTile from './components/ResourcesTile';
import RecentCases from 'components/Cases/RecentCases';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import DownloadsTile from './components/DownloadsTile';
import IntegrationsTile from './components/IntegrationsTile';
import { secondaryText } from 'utils/colors';
import InvestmentAnalyserTile from './components/InvestmentAnalyserTile';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginTop: '2rem',
      '& .MuiGrid-item': {
        display: 'grid'
      }
    },
    box: {
      overflow: 'hidden'
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    },
    grid: {
      height: 'calc(100% - 24px)'
    },
    links: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      justifyContent: 'end',
      margin: '1rem 0'
    },
    link: {
      textDecoration: 'none',
      color: secondaryText,
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    resourceColumn: {
      [theme.breakpoints.up('xs')]: {
        flexDirection: 'column'
      },
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row'
      },
      [theme.breakpoints.up('md')]: {
        flexDirection: 'column'
      }
    }
  })
);

const HomepageComponent = () => {
  const classes = useStyles();

  return (
    <div style={{ display: 'flex', minHeight: 'calc(100vh - 69px)' }}>
      <div className={classes.root}>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="stretch"
          className={classes.grid}
        >
          <Grid item xs={12} sm={6} md={4}>
            <RecentCases />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid
              container
              spacing={3}
              direction="column"
              justifyContent="space-between"
              alignItems="stretch"
            >
              <Grid item xs>
                <InvestmentAnalyserTile />
              </Grid>
              <Grid item xs>
                <InvestmentPropositionTile />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid
              container
              className={classes.resourceColumn}
              spacing={3}
              justifyContent="space-between"
              alignItems="stretch"
            >
              <Grid item xs>
                <IntegrationsTile />
              </Grid>
              <Grid item xs>
                <ResourcesTile />
              </Grid>
              <Grid item xs>
                <DownloadsTile />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.links}>
          <a
            rel="noopener noreferrer"
            href="https://fintegrate.co.uk/terms/"
            target="_blank"
            className={classes.link}
          >
            Terms
          </a>
          <a
            rel="noopener noreferrer"
            href="https://fintegrate.co.uk/privacy/"
            target="_blank"
            className={classes.link}
          >
            Privacy
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomepageComponent;
